var map = {
	"./ar/menu.json": 60562,
	"./cy/menu.json": 12270,
	"./cz/menu.json": 98463,
	"./da/menu.json": 95545,
	"./de/menu.json": 86565,
	"./en/menu.json": 99800,
	"./es/menu.json": 55617,
	"./fi/menu.json": 39864,
	"./fr/menu.json": 45401,
	"./hu/menu.json": 54121,
	"./it/menu.json": 22349,
	"./ja/menu.json": 32435,
	"./ko/menu.json": 32502,
	"./kz/menu.json": 34320,
	"./nl/menu.json": 68609,
	"./pl/menu.json": 17359,
	"./pt/menu.json": 84404,
	"./ro/menu.json": 37756,
	"./ru/menu.json": 49343,
	"./sk/menu.json": 26508,
	"./sv/menu.json": 31730,
	"./vn/menu.json": 17109
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22662;